import { UNAUTHORIZED_LOCAL_STORAGE_LOCALE } from '../constants';
import { LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY } from '../pages/report/@data/store/store';

export const clearLocalStorageProtected = (keys?: string[]) => {
  // add any other keys wanted to keep the value after the storage clear
  const keysToKeep = [UNAUTHORIZED_LOCAL_STORAGE_LOCALE, LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY, ...(keys || [])];

  const values = keysToKeep.map((key) => localStorage.getItem(key));
  localStorage.clear();
  values.forEach((value, index) => {
    if (value) {
      localStorage.setItem(keysToKeep[index], value);
    }
  });
};
